(function () {
  function syncThumb(grid, thumb) {
    var thumbRatio = grid.clientWidth / grid.scrollWidth;
    var maxScroll = grid.scrollWidth - grid.clientWidth;
    var scrollRatio = maxScroll > 0 ? grid.scrollLeft / maxScroll : 0;
    var thumbPercent = thumbRatio * 100;
    thumb.style.width = thumbPercent + '%';
    thumb.style.marginInlineStart = scrollRatio * (100 - thumbPercent) + '%';
  }

  function updateScrollState(grid) {
    var section = grid.closest('.nuestras-gamas');
    var track = section && section.querySelector('[data-3dids-scrollbar-track]');
    var thumb = section && section.querySelector('[data-3dids-scrollbar-thumb]');
    var previous = section && section.querySelector('[data-3dids-carousel-previous]');
    var next = section && section.querySelector('[data-3dids-carousel-next]');

    var hasOverflow = grid.scrollWidth > grid.clientWidth + 1;
    var maxScroll = Math.max(0, grid.scrollWidth - grid.clientWidth);
    var currentScroll = Math.max(0, grid.scrollLeft);

    if (previous) previous.disabled = !hasOverflow || currentScroll <= 1;
    if (next) next.disabled = !hasOverflow || currentScroll >= maxScroll - 1;

    if (track && thumb) {
      track.classList.toggle('nuestras-gamas__has-scroll', hasOverflow);

      if (hasOverflow) {
        syncThumb(grid, thumb);
      }
    }

    if (!grid.dataset.carouselBound) {
      grid.dataset.carouselBound = 'true';

      grid.addEventListener('scroll', function () {
        updateScrollState(grid);
      });

      if (previous) {
        previous.addEventListener('click', function () {
          scrollOneCard(grid, -1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          scrollOneCard(grid, 1);
        });
      }
    }
  }

  function scrollOneCard(grid, direction) {
    var card = grid.querySelector('.nuestras-gamas__card');
    if (!card) return;

    var styles = window.getComputedStyle(grid);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;

    grid.scrollBy({
      left: direction * (card.getBoundingClientRect().width + gap),
      behavior: 'smooth',
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.nuestras-gamas__grid').forEach(updateScrollState);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  window.addEventListener('resize', function () {
    init();
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
